import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { Observable } from "rxjs";
import { AuthService } from "../auth/auth.service";
import { HttpModel } from '../../models/http-details';

@Injectable({
  providedIn: "root",
})
export class HttpService {
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService
  ) {}

  invokeHttp(
    httpObj: HttpModel,
    showLoader: boolean = true,
    skipGlobalError: boolean = false
  ): Observable<HttpResponse<Object>> {
    const serviceURL = environment.apiUrl + httpObj.partialURL;

    let params = new HttpParams();
    if (httpObj.queryParams != null) {
      Object.entries(httpObj.queryParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          params = params.append(key, value.toString());
        }
      });
    }

    let headers = new HttpHeaders({ Accept: "application/json" });

    // if (environment.useCookies) {
        const token = this.authService.getAccessToken();
        if (token) {
          headers = headers.set("Authorization", `Bearer ${token}`);
        }
    // }

    const context = new HttpContext();

    switch (httpObj.callType) {
      case "GET":
        return this.httpClient.get(serviceURL, {
          headers,
          observe: "response",
          params,
          context,
          withCredentials: !environment.useCookies,
        });

      case "POST":
        return this.httpClient.post(serviceURL, httpObj.dataJSON, {
          headers,
          observe: "response",
          responseType: httpObj.responseType,
          context,
          params,
          withCredentials: !environment.useCookies,
        });

      case "PUT":
        return this.httpClient.put(serviceURL, httpObj.dataJSON, {
          headers,
          observe: "response",
          responseType: httpObj.responseType,
          context,
          withCredentials: !environment.useCookies,
        });

      case "DELETE":
        return this.httpClient.delete(serviceURL, {
          headers,
          observe: "response",
          params,
          body: httpObj.dataJSON, // Add body support for DELETE
          responseType: httpObj.responseType,
          context,
          withCredentials: !environment.useCookies,
      });
  
      case "PATCH":
        return this.httpClient.patch(serviceURL, httpObj.dataJSON, {
          headers,
          observe: "response",
          responseType: httpObj.responseType,
          context,
          withCredentials: !environment.useCookies,
        });

      default:
        throw new Error(`Unsupported call type: ${httpObj.callType}`);
    }
  }
}
